"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var arrayType = require("./array");
var booleanType = require("./boolean");
var dateTimeType = require("./date-time");
var enumType = require("./enum");
var numberType = require("./number");
var objectType = require("./object");
var oneOfType = require("./oneOf");
var stringType = require("./string");
exports.getDataModel = function (schema) {
    if (!schema) {
        return null;
    }
    var format = schema.format, type = schema.type;
    if (schema.enum) {
        return enumType;
    }
    if (schema.oneOf) {
        return oneOfType;
    }
    if (type === 'array') {
        return arrayType;
    }
    if (type === 'string') {
        if (format === 'date-time') {
            return dateTimeType;
        }
        return stringType;
    }
    if (type === 'object') {
        return objectType;
    }
    if (type === 'boolean') {
        return booleanType;
    }
    if (type === 'number') {
        return numberType;
    }
    return null;
};



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/rendition/dist/components/DataTypes/index.js
// module id = 241
// module chunks = 2